import React, { createContext, useState, useEffect } from 'react';
import {getLocalItem, setLocalItem} from "../libs/helpers";

const AppContext = createContext({});
const AppContextProvider = ({ children }) => {
    const [appData, setAppData] = useState(()=>{
        const data = getLocalItem('appData');
        return data || {};
    });

    useEffect(()=>{
        setLocalItem('appData', appData);
    },[appData]);

    return (
        <AppContext.Provider value={{appData, setAppData}}>
            {children}
        </AppContext.Provider>
    )
}

export { AppContext, AppContextProvider };
